import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { CheckCircleIcon, XCircleIcon, AlertTriangleIcon } from 'lucide-react';
export function HelmetLaw() {
  return <div className="min-h-screen bg-[#0a0a0a] safe-bottom" data-id="element-188">
      <PageHeader title="MI Helmet Law" subtitle="When you can ride without a helmet" data-id="element-189" />

      <main className="px-4 py-6" data-id="element-190">
        {/* Main Rule */}
        <motion.div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-5 mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} data-id="element-191">
          <h2 className="text-lg font-bold text-white mb-3" data-id="element-192">
            Riders 21+ Can Go Helmetless IF:
          </h2>
          <div className="space-y-3" data-id="element-193">
            <div className="flex gap-3" data-id="element-194">
              <CheckCircleIcon className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-195" />
              <p className="text-[#a3a3a3] text-sm" data-id="element-196">
                You have at least{' '}
                <span className="text-white font-semibold" data-id="element-197">$20,000</span> in
                first-party medical benefits insurance
              </p>
            </div>
            <div className="flex gap-3" data-id="element-198">
              <CheckCircleIcon className="w-5 h-5 text-[#22c55e] flex-shrink-0 mt-0.5" data-id="element-199" />
              <p className="text-[#a3a3a3] text-sm" data-id="element-200">
                You have passed a motorcycle safety course{' '}
                <span className="text-white font-semibold" data-id="element-201">OR</span> have held a
                motorcycle endorsement for 2+ years
              </p>
            </div>
          </div>
        </motion.div>

        {/* Requirements Grid */}
        <div className="grid grid-cols-2 gap-3 mb-6" data-id="element-202">
          <motion.div className="bg-[#22c55e]/10 border border-[#22c55e]/30 rounded-2xl p-4" initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.1
        }} data-id="element-203">
            <CheckCircleIcon className="w-8 h-8 text-[#22c55e] mb-2" data-id="element-204" />
            <p className="text-white font-semibold text-sm mb-1" data-id="element-205">21 or Older</p>
            <p className="text-[#a3a3a3] text-xs" data-id="element-206">
              With proper insurance & experience
            </p>
          </motion.div>

          <motion.div className="bg-[#dc2626]/10 border border-[#dc2626]/30 rounded-2xl p-4" initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-207">
            <XCircleIcon className="w-8 h-8 text-[#dc2626] mb-2" data-id="element-208" />
            <p className="text-white font-semibold text-sm mb-1" data-id="element-209">Under 21</p>
            <p className="text-[#a3a3a3] text-xs" data-id="element-210">
              Helmet mandatory, no exceptions
            </p>
          </motion.div>
        </div>

        {/* Passenger Rules */}
        <motion.div className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-2xl p-5 mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} data-id="element-211">
          <h3 className="text-white font-bold mb-3" data-id="element-212">Passenger Requirements</h3>
          <p className="text-[#a3a3a3] text-sm leading-relaxed" data-id="element-213">
            All passengers must{' '}
            <span className="text-white" data-id="element-214">
              independently meet the same requirements
            </span>{' '}
            to ride without a helmet. Being on a bike with a qualified rider
            doesn't exempt the passenger.
          </p>
        </motion.div>

        {/* Violation Info */}
        <motion.div className="bg-[#d4a853]/10 border border-[#d4a853]/30 rounded-2xl p-4 mb-6" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} data-id="element-215">
          <div className="flex gap-3" data-id="element-216">
            <AlertTriangleIcon className="w-6 h-6 text-[#d4a853] flex-shrink-0" data-id="element-217" />
            <div data-id="element-218">
              <p className="text-[#d4a853] font-semibold mb-1" data-id="element-219">
                Violation Penalty
              </p>
              <p className="text-[#a3a3a3] text-sm" data-id="element-220">
                Riding without a helmet when not qualified is a civil infraction
                with fines. It can also affect insurance claims if you're in an
                accident.
              </p>
            </div>
          </div>
        </motion.div>

        {/* Insurance Tip */}
        <motion.div className="bg-[#252525] rounded-2xl p-4" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.5
      }} data-id="element-221">
          <p className="text-white font-semibold mb-2" data-id="element-222">💡 Pro Tip</p>
          <p className="text-[#a3a3a3] text-sm" data-id="element-223">
            Keep proof of your $20k+ medical coverage with your registration.
            Officers may ask for it during stops.
          </p>
        </motion.div>
      </main>
    </div>;
}